
import banner from '../images/login-banner.png';

function JoyyaHeader() {
  return (
    <>
      <div style={{
        background: 'linear-gradient(to right, #ffbf00, 50%, #ed8a15 50%)',
        top: '0px',
        marginBottom: '-20px',
        position: 'sticky',
        height: '80px',
        width: '100%',
        zIndex: '1',
      }}>
        <div style={{ textAlign: 'center' }}>
          <img src={banner} alt="Joyya logo banner" style={{ maxHeight: '80px' }} />
        </div>
      </div>
    </>
  );
}

export { JoyyaHeader }
